/**
 * Welches Hilfethema zu welcher Seite gehört. Der Knopf „Hilfe“ im Kopf
 * springt damit direkt dorthin, wo die Seite erklärt wird, statt an den
 * Anfang einer langen Hilfeseite.
 */
const THEMA_JE_SEITE: [prefix: string, thema: string][] = [
  ["/import", "import"],
  ["/kassen-review", "klaeren"],
  ["/betriebstage", "rechnen"],
  ["/auszahlungen", "auszahlen"],
  ["/monat", "monat"],
  ["/aushang", "monat"],
  ["/auswertung", "auswertung"],
  ["/stammdaten", "stammdaten"],
  ["/audit", "fragen"],
  ["/konto", "anmelden"],
];

/** `/auszahlungen` → `auszahlen`; die Übersicht und Unbekanntes → `ablauf`. */
export function hilfeThemaFuer(pathname: string): string {
  return THEMA_JE_SEITE.find(([p]) => pathname === p || pathname.startsWith(`${p}/`))?.[1] ?? "ablauf";
}
